import { render, staticRenderFns } from "./EditCompanyAffiliationModal.vue?vue&type=template&id=c85985de&scoped=true&"
import script from "./EditCompanyAffiliationModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyAffiliationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85985de",
  null
  
)

export default component.exports